import axios from 'axios'
import ApiHelper from '@/services/ApiHelper'
import router from '@/router/index'

export default ({
  modules: {
  },
  state: {
    user: {},
    token: localStorage.getItem('token') || '',
    status: null,
    users: []
  },
  mutations: {
    // Will set the status to loading
    loadingMutation (state) {
      state.status = 'loading'
    },

    // Will set the loading and token to success
    loginSuccessMutation (state, params) {
      state.status = 'success'
      state.token = params.token
      state.user = params.user
    },

    // Will set the loading as false
    loginFailureMutation (state) {
      state.status = 'failure'
      state.token = ''
      state.user = {}
    },

    logoutMutation (state) {
      state.user = ''
      state.token = ''
      state.status = null
    },

    fetchUsersMutation (state, users) {
      state.users = users
    }
  },
  actions: {
    registerAction ({ commit }, userDetails) {
      return new Promise((resolve, reject) => {
        ApiHelper.register(userDetails)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    resetPasswordAction ({ commit }, recoveryLink) {
      return new Promise((resolve, reject) => {
        ApiHelper.resetPassword(recoveryLink)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    fetchRecoveryLinkAction ({ commit }, recoveryLink) {
      return new Promise((resolve, reject) => {
        ApiHelper.fetchRecoveryLink(recoveryLink)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    createRecoveryLinkAction ({ commit }, email) {
      return new Promise((resolve, reject) => {
        ApiHelper.createRecoveryLink(email)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // Will be called from the components and call to the loginMutation
    loginAction ({ commit }, userDetails) {
      // Update the state to loading
      commit('loadingMutation')
      return new Promise((resolve, reject) => {
        ApiHelper.login(userDetails)
          .then(response => {
            // Successful response, save the response to the vuex store
            const token = response.access_token
            const user = response.user
            commit('loginSuccessMutation', { token: token, user: user })
            // save the token to the localStorage and update to the axios
            localStorage.setItem('token', token)
            axios.defaults.headers.common.Authorization = token
            resolve(response)
          })
          .catch(error => {
            // Failure to login, remove the token if any
            commit('loginFailureMutation')
            // localStorage.removeItem('token')
            reject(error)
          })
      })
    },

    refreshAction ({ commit }) {
      const token = localStorage.getItem('token')
      if (!token) { return }
      return new Promise((resolve, reject) => {
        ApiHelper.refresh(token)
          .then(response => {
            // Successful response, save the response to the vuex store
            const token = response.access_token
            const user = response.user
            commit('loginSuccessMutation', { token: token, user: user })
            // save the token to the localStorage and update to the axios
            localStorage.setItem('token', token)
            axios.defaults.headers.common.Authorization = token
            resolve(response)
          })
          .catch(error => {
            // Failure to login, remove the token if any
            commit('loginFailureMutation')
            localStorage.removeItem('token')
            reject(error)
          })
      })
    },

    fetchUsersAction ({ commit }, filter) {
      return new Promise((resolve, reject) => {
        ApiHelper.fetchUsers(filter)
          .then(response => {
            commit('fetchUsersMutation', response.users)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    logoutAction ({ commit }) {
      commit('logoutMutation')
      localStorage.removeItem('token')
      router.push('/')
    }
  },
  getters: {
    isLoggedIn: state => state.status === 'success',
    username: state => state.user.username,
    user: state => state.user,
    status: state => state.status,
    token: state => state.token,
    isAdmin: state => state.user.admin,
    hasOnlineSubscription: state => state.user.has_online_subscription,
    users: state => state.users
  }
})
